<template>
  <div>
    <UiButton
      data-testid="dropdown-menu-button"
      position="TOP_RIGHT"
      @click="emit('toggleAction')"
    >
      <div :class="getMenuButtonClasses">
        <div class="menubutton__usericon">
          <span data-testid="menubutton-usericon">
            {{ currentUserInitials }}
          </span>
        </div>
        <div class="menubutton__userinfo">
          <div class="menubutton__fullname subtitle-2">
            <span data-testid="menubutton-fullname">
              {{ userName }}
            </span>
          </div>
          <div
            class="menubutton__carriername"
            data-testid="menubutton-carriername"
          >
            {{ companyName }}
          </div>
        </div>
        <span class="menubutton__menuicon">
          <ui-icon type="round"> menu </ui-icon>
        </span>
      </div>
    </UiButton>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useUserDetailsStore } from '@/stores/useUserDetails';

const emit = defineEmits(['toggleAction']);

const props = defineProps({
  isProfile: {
    type: Boolean,
    default: false,
  },
});

const { currentUserInitials, userName, companyName } = storeToRefs(useUserDetailsStore());

const getMenuButtonClasses = computed(() => {
  return ['menubutton', props.isProfile ? 'menubutton--profile' : ''];
});
</script>

<style lang="scss" scoped>
.menubutton {
  @apply tw-flex tw-cursor-pointer tw-flex-row tw-items-center tw-justify-center tw-text-black-500;

  .menubutton__usericon {
    @apply tw-bg-primary-base tw-text-center tw-font-medium tw-capitalize tw-text-white;

    height: 30px;
    width: 30px;
    border-radius: 100px;
    font-size: 16px;
    line-height: 30px;

    @screen tw-md {
      margin-right: 10px;
    }
  }

  .menubutton__userinfo {
    @apply tw-hidden tw-flex-col tw-items-start tw-md:tw-flex;
    padding-right: 23px;
    line-height: 1;
  }

  .menubutton__fullname {
    @apply tw-mb-1 tw-text-left tw-font-medium tw-text-grey-dark;
  }

  .menubutton__carriername {
    @apply tw-text-xs tw-font-regular tw-capitalize tw-text-grey-dark;
  }

  .menubutton__menuicon {
    @apply tw-hidden tw-text-grey-dark tw-md:tw-flex;
  }

  &.menubutton--profile {
    .menubutton__usericon {
      margin-right: 18px;

      @apply tw-h-8 tw-w-8 tw-leading-8;
    }

    .menubutton__fullname {
      @apply tw-mb-1 tw-text-base tw-leading-6 tw-text-grey-dark-x;
      letter-spacing: 0.25px;
    }

    .menubutton__carriername {
      @apply tw-text-sm;
      letter-spacing: 0.25px;
      line-height: 21px;
    }

    .menubutton__userinfo {
      @apply tw-block;
    }
  }

  .menubutton__admin {
    @apply tw-relative -tw-top-1 tw-left-3 tw-scale-75 tw-rounded-full tw-border tw-border-solid tw-bg-white tw-p-1 tw-text-drivably-primary-base;
  }
}
</style>
